// extracted by mini-css-extract-plugin
export default {"SendFileForMessage":"IbGM_9HEUyDlVnURDLqK","SendFile":"wnSd9BmzOVO1FzdhdQcz"};